import * as React from "react";
function SvgStethoscope(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.8 15.526a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm3.2-1.2a3.201 3.201 0 01-2.035 2.982 7.472 7.472 0 01-.933 2.67c-.78 1.318-2.193 2.615-4.532 2.615-1.104 0-2.043-.253-2.819-.722-.774-.467-1.331-1.116-1.726-1.827C8.18 18.65 8 16.966 8 15.66V12.522c-.933-.137-1.73-.47-2.396-.966-.884-.658-1.469-1.551-1.853-2.489-.758-1.846-.805-4.028-.72-5.53a19.891 19.891 0 01.208-1.959l.02-.122.007-.034.002-.01v-.005l.983.186.983.187-.001.004-.004.022-.017.096a17.89 17.89 0 00-.185 1.747C4.96 4.872 5 6.395 5.39 7.705c.79-.59 1.966-1.112 3.61-1.112s2.82.523 3.61 1.112c.39-1.31.431-2.833.363-4.056a17.9 17.9 0 00-.185-1.747 8.688 8.688 0 00-.017-.096l-.004-.022V1.78l.982-.187.982-.186v.002l.001.003.002.01.006.034a10.802 10.802 0 01.086.563c.05.374.11.9.144 1.518.084 1.502.037 3.684-.72 5.53-.385.938-.97 1.83-1.854 2.489-.666.496-1.463.83-2.396.966V15.661c0 1.178.174 2.46.703 3.412.257.461.587.83 1.012 1.087.423.255.995.433 1.785.433 1.45 0 2.287-.75 2.81-1.634a5.415 5.415 0 00.607-1.556 3.201 3.201 0 01.883-6.277 3.2 3.2 0 013.2 3.2zM11.67 9.52a3.051 3.051 0 00-.17-.146c-.46-.368-1.243-.78-2.5-.78s-2.04.412-2.5.78c-.062.05-.118.098-.17.146.143.161.299.306.468.432.509.378 1.207.641 2.202.641.995 0 1.693-.263 2.202-.641.169-.126.325-.27.467-.432z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgStethoscope);
export default ForwardRef;
